export default function MOMENT() {
    'ngInject';

    return {
        format: (...args) => {
            const [date, format] = args;
            return moment(date).format(format);
        },
        init: () => moment(),
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/common/wrappers/MOMENT.js